// lib
import React, { useState } from "react";
import PropTypes from "prop-types";
import { filter } from "ramda";
import { useTranslation } from "react-i18next";
import { IconButton, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Add } from "@material-ui/icons";
// src
import Select from "../partials/Select";
import { CAMPUSES, CAMPUSES_DISPLAY } from "./filters";

const getDisplayeds = (items, campus) => {
  if (!items) return [];
  if (campus) {
    return filter(({ campus: c }) => c === campus, items);
  }
  return items;
};

const Rooms = ({ createHandleSelect, items, selfTranslate }) => {
  const [campus, setCampus] = useState();
  const { t } = useTranslation();
  const displayeds = getDisplayeds(items, campus);
  return (
    <>
      <Select
        defaultLabel={t("common.campus")}
        values={CAMPUSES}
        labels={CAMPUSES_DISPLAY}
        selectCallback={setCampus}
      />
      <List dense>
        {displayeds.map((i) => (
          <ListItem key={i.id}>
            <ListItemIcon onClick={createHandleSelect(i)}>
              <IconButton size="small" className={i.campus ? `add--${i.campus}` : "add"}>
                <Add />
              </IconButton>
            </ListItemIcon>
            <ListItemText primary={selfTranslate(i.name)} />
          </ListItem>
        ))}
      </List>
    </>
  );
};

Rooms.propTypes = {
  // from parent
  createHandleSelect: PropTypes.func.isRequired,
  selfTranslate: PropTypes.func.isRequired,
  items: PropTypes.array,
};

Rooms.defaultProps = {
  items: [],
};

export default Rooms;
